export enum EnvelopeSortField {
    title = 0,
    creationDate = 1,
    conclutionDate = 2
}
